<template>
	<div class="m-text">
		<div class="tool">
			<!--表情-->
			<el-popover ref="popver" placement="top-start" width="400" trigger="click">
        <div class="emojis">
          <div v-for="item in emojiName" class="emoji" :key="item" @click="sendEmojiIcon(item)">
            <img :src="emojiUrl + emojiMap[item]" class="emojiImg"/>
          </div>
        </div>
				<el-button class="fa fa-smile-o" size="big" type="text" slot="reference" title="表情" style="transform: scale(1.5);margin-right:10px"></el-button>
			</el-popover>
			<!--文件-->
			<el-upload 
			class="upload-demo" 
			action="https://jsonplaceholder.typicode.com/posts/" 
			multiple 
			:http-request="beforeAvatarUpload" 
			:show-file-list="false"
			:before-upload="beforeAvatarUploadPdf">
				<el-button class="el-icon-folder" type="text" title="发送文件" size="big" style="transform: scale(1.5);margin-right:10px"></el-button>
			</el-upload>
			<!--聊天记录-->
			<el-button class="el-icon-chat-dot-round" type="text" slot="reference" title="聊天记录" @click="openHistory" style="transform: scale(1.5);margin-right:10px"></el-button>
		</div>
		<!--<textarea id="charInput" placeholder="按 Ctrl + Enter 发送" v-model="text" @keyup="inputing"></textarea>-->
		<div ref="text" id="charInput" contenteditable="true" 
			@keydown.ctrl.enter="inputing" 
			@keypress.enter.stop.prevent="sendMethod"
			@paste="copyPaste"
			@click="changebadge">
			
		</div>
		<chat-upload ref="uploadFile" :file="file" :isShow="true" v-show="Object.keys(file).length !== 0"></chat-upload>
		<el-button class="sendBtn" @click="sendMethod" type="info" size="small">发送</el-button>
		<History ref="History" :data="session"></History>
	</div>
</template>

<script>
  import {emojiMap, emojiName, emojiUrl} from '@/mqtt/emojiMap'
	import chatUpload from "./upload"
	import axios from "@/http/axios"
	import jquery from 'jquery'
	import html2canvas from "html2canvas"
	import History from "./history"
	let emojiData = require('../../assets/emoji/emoji.json')
	export default {
		props: ['session','user','userList','isemptyShow'],
		components: {
			chatUpload,
			History
		},
		data() {
			return {
        emojiMap: emojiMap,
        emojiName: emojiName,
        emojiUrl: emojiUrl,
				text: '',
				inputRange: '', // 光标
				file: {},
				receiveData:null,
				downloadUrl:'',
				base64Img:[],
				srcReg : /src=[\'\"]?([^\'\"]*)[\'\"]?/i,
				filetype:'' // 区分上传的是图片还是文件
			};
		},
		methods: {
			changebadge(){		
				this.$emit('changebadge',this.session.userId)
			},
			// 获取图片地址
			getImgSrc(data){
				let imgReg = /<img.*?(?:>|\/>)/gi //匹配图片中的img标签
				let str = data
				let arr = str.match(imgReg) //筛选出所有的img
				return arr
			},
			// 上传图片
			uploadPasteImg(data){
				let arr = [];
				return new Promise((res,rej) => {
					data.forEach(async element => {
						let fd = new FormData();
		        fd.append("baseStr",element.match(this.srcReg)[1]);
		        fd.append("type",this.fileType);
		        await axios({
		          hostUrl:this.zuul,
		          url:"/xyj-admin/r/FileUploadController/uploadFileTypeByBase64",
		          method:"post",
		          data:fd
		        }).then(res =>{
		          arr.push({base:element.match(this.srcReg)[1],htp:res}) 
		        }).catch(err =>{
		          this.$message.error(err.message)
		        })
		        if(arr.length == data.length) {
			        res(arr);
			      }
		      })
				})
			},
			inputing(e) {
				if(this.$refs.text.innerHTML.toString().indexOf('<br>') > -1){
					this.$refs.text.innerHTML += '<br />'
				}else{
					this.$refs.text.innerHTML += '<br /><br />'
				}
				//设置输入焦点
        let o = document.getElementById("charInput").lastChild;            
        let textbox = document.getElementById('charInput');
        let sel = window.getSelection();
        let range = document.createRange();
        range.selectNodeContents(textbox);
        range.collapse(false);
        range.setEndAfter(o);
        range.setStartAfter(o);
        sel.removeAllRanges();
        sel.addRange(range);
			},
			// 发送消息
			chatMsg(msg,type){
				this.$api.im.sendMessage({
					fromUserId:this.$mqtt._clientId,
					messageString:msg,
					messageType:type,
					toUserId:this.session.conversationid,
					toUserNickName:this.session.name,
					topic:this.$topic.$IMNEWS,
					toUserHeadLogo:this.session.friendHeadportrait,
					fromUserNickName:this.session.fromUserNickName,
					fromUserLogo:this.session.fromUserLogo
				}).then(res => {
					// this.$refs.text.innerHTML = ''
				})
			},
			/**
			 *张俊娜：2019/12/4
			 *描述：发送消息
			 *版本：1.0
			 */
			sendMethod() {
				let contentText = JSON.parse(JSON.stringify(this.$refs.text.innerHTML));
				contentText = contentText.replace(/<br>/g,'')
				if(this.$refs.text.innerHTML){			
					// 删除显示的文件图片
					jquery('#charInput .fileImg').remove()
					// 发送文本
					this.chatMsg(contentText,this.$topic.$MESSAGETYPE.ChatText)
					this.$refs.text.innerHTML = ''
					this.session.messages.push({
						type:this.$topic.$MESSAGETYPE.ChatText,
						text: contentText,
						date: new Date(),
						self: true,
						alreadyread:0
					});
					this.file = {}
					// 发送文件
					/*if(Object.keys(this.file).length !== 0){
						this.chatMsg(JSON.stringify({msg:{name:this.file.name,size:(this.file.size/1024).toFixed(1)},fileurl:this.downloadUrl}),this.$topic.$MESSAGETYPE.ChatFile)
						this.session.messages.push({
							type:this.$topic.$MESSAGETYPE.ChatFile,
							text: {name:this.file.name,size:(this.file.size/1024).toFixed(1)},
							fileUrl:this.downloadUrl,
							date: new Date(),
							self: true,
							alreadyread:0
						}); 
						this.file = {}
					}else{
						let imgUrl = '';
						let msg = contentText;
						let sessionPush = msg;
						// 文件上传的图片
						if(msg.indexOf('photo') > -1){
							let imgReg = /<img.*?(?:>|\/>)/gi;
							let textvalue = JSON.parse(JSON.stringify(msg.replace(imgReg,'')))
							if(!textvalue){
								// 只有单张图片
								this.session.messages.push({
									type:this.$topic.$MESSAGETYPE.ChatImage,
									text: msg,
									date: new Date(),
									self: true,
									imgurl: msg.match(this.srcReg)[1],
									alreadyread:0
								});
								this.$refs.text.innerHTML = ''
								this.chatMsg(msg,this.$topic.$MESSAGETYPE.ChatImage)
							}else{
								//文字和图片
								console.log(msg,msg.split(imgReg))	
								console.log(msg.match(/<img.+?>/ig))	
								// this.session.messages.push({
								// 	type:this.$topic.$MESSAGETYPE.ChatImage,
								// 	text: msg,
								// 	date: new Date(),
								// 	self: true,
								// 	imgurl: '',
								// 	alreadyread:0
								// });
								// this.$refs.text.innerHTML = ''
								// this.chatMsg(msg,this.$topic.$MESSAGETYPE.ChatImage)
							}
						}else if(msg.indexOf('data:image/png') > -1){
							// 发送截图
							this.session.messages.push({
								type:this.$topic.$MESSAGETYPE.ChatImage,
								text: msg,
								date: new Date(),
								self: true,
								imgurl: msg.match(this.srcReg)[1],
								alreadyread:0
							});
							// 上传图片
							this.uploadPasteImg(this.getImgSrc(msg)).then((element) => {
								element.forEach(data => {
									msg = msg.replace(data.base, data.htp)
								})
								this.getImgSrc(msg).forEach(val => {
									if(!(val.toString().indexOf('pasteImg') > -1) && !(val.toString().indexOf('uploadBorder') > -1)) {
										let src = val.match(this.srcReg)
										// 获取图片地址
										imgUrl = src[1]
									}
									
									this.$refs.text.innerHTML = ''
									this.chatMsg(val,this.$topic.$MESSAGETYPE.ChatImage)
								})
								this.file = {}
							})	
						}else{
							this.$refs.text.innerHTML = ''
							// 发送文本
							this.chatMsg(msg,this.$topic.$MESSAGETYPE.ChatText)
							this.session.messages.push({
								type:this.$topic.$MESSAGETYPE.ChatText,
								text: sessionPush,
								date: new Date(),
								self: true,
								alreadyread:0
							});
							this.file = {}
						//}
					}*/
				}
			},
			/**
			 *张俊娜：2019/11/25 14:38
			 *描述：推送页面消息 接收消息
			 *版本：1.0
			 */
			imMessageArrived: function(payloadMessage) {
				this.receiveData = payloadMessage
				this.$message.info(payloadMessage.payloadString);
			},
			/**
			 *张俊娜：2019/11/25 14:38
			 *描述：推送页面消息 接收消息
			 *版本：1.0
			 */
			imMessageDelivered: function(message) {
				this.receiveData = null
			},
			/**
			 *张俊娜：2019/11/28 17:18
			 *描述：广播消息
			 *版本：1.0
			 */
			broadcastArrived: function(payloadMessage) {
				if(JSON.parse(payloadMessage.payloadString).messageType == 21){
					// 有申请好友消息
					this.$emit('updatebadge')
					this.$emit('hasNewFriend')
					return 
				}
				// 没有打开会话
				if(this.isemptyShow){ 
					// 更新聊天信息
					this.$emit('updateMsg',null)
					//对应会话消息未读+1
					this.userList.filter(item => item.conversationid == JSON.parse(payloadMessage.payloadString).fromUserId)[0].unRead += 1
					// 更新总的未读消息数
					this.$emit('updatebadge')
					return 
				}
				// 当前收到的消息是正在聊天的人
				if(JSON.parse(payloadMessage.payloadString).data == this.session.conversationid ||
				JSON.parse(payloadMessage.payloadString).fromUserId == this.session.conversationid){
					// 已读消息
					if(JSON.parse(payloadMessage.payloadString).messageType == 'read'){
						// 将消息改为已读状态
						this.session.messages.forEach(x => {
							x.alreadyread = 1
						})
						return
					}
					/**
					 *张俊娜：2019/12/26
					*描述：改变未读状态
					*版本：1.0
					*/
						axios({
							hostUrl:this.zuul,
							url:'/xyj-im/r/imChatHistory/readMessage?fromchatid='+sessionStorage.getItem('chatid')+'&tochatid='+this.session.conversationid+'&topic='+this.$topic.$IMNEWS,
							method:'get'
						}).then(res => {
							if(res.code == 200){
								// 更新总的未读消息数
								this.$emit('updatebadge')
								this.receiveData = payloadMessage
								// 更新聊天信息
								this.$emit('updateMsg',JSON.parse(payloadMessage.payloadString).fromUserId)

								this.session.unRead = 0
							}
						}).catch(err => {
							this.$message.error(err.message)
						})
						
				}else{
					//对应会话消息未读+1
					this.userList.filter(item => item.conversationid == JSON.parse(payloadMessage.payloadString).fromUserId)[0].unRead += 1
					// 更新总的未读消息数
					this.$emit('updatebadge')
				}
			},
			// 获取历史消息
			getHistory(id){
				let params = '?page=1&pageSize=10'+'&tochatid='+this.session.conversationid+'&fromchatid='+sessionStorage.getItem('chatid')
				axios({
			    hostUrl: this.zuul,
			    url: '/xyj-im/r/imChatHistory/findChatHistory'+params,
			    method: 'get',
			  }).then((res)=>{		
					if(id && id == this.session.conversationid){
						this.session.messages = res.data.rows.map(item => {
							let obj = {};
							obj.text = item.chatcontent;
							obj.date = item.createTime;
							obj.self = item.fromchatid == this.session.conversationid ? false : true;
							obj.alreadyread = item.alreadyread;
							obj.type = item.chattype;
							obj.id = item.id;
							if(item.chatcontent.toString().indexOf('img') > -1 && !(item.chatcontent.toString().indexOf('pasteImg') > -1)) {
								let imgReg = /<img.*?(?:>|\/>)/gi //匹配图片中的img标签
								let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片中的src
								let str = item.chatcontent
								let arr = str.match(imgReg) //筛选出所有的img
								if(arr) {
									for(let i = 0; i < arr.length; i++) {
										let src = arr[i].match(srcReg)
										// 获取图片地址
										obj.imgurl = src[1]
									}
								}
							}
							if(item.chatcontent.toString().indexOf('msg') > -1){
								obj.text = JSON.parse(item.chatcontent).msg,
								obj.fileUrl = JSON.parse(item.chatcontent).fileurl,
								obj.date = new Date(),
								obj.imgurl = ''
							}
							return obj
						}).reverse()
					}
        }).catch((error)=>{
        	this.loading = false
          this.$message.error(error.message);
        })
			},
			/**
			 *张俊娜：2019/11/28 17:19
			 *描述：广播消息
			 *版本：1.0
			 */
			broadcastDelivered: function(message) {
			},
			/**
			 *张俊娜：2019/12/4
			 *描述：点击表情，将表情添加到输入框
			 *版本：1.0
			 */
			sendEmojiIcon(item, type) {
				this.$refs.popver.showPopper = false;
        let inputNode = document.getElementById('charInput')
				// let html = "<img class='pasteImg' src='" + emojiUrl + emojiMap[item] + "' alt='' >"
        let html = item;
				if(type == 2) {
					html = "<img class='fileImg' src='" + item + "' alt='' >"
				}else if(type == 1){
					html = "<img class='photo' src='" + item + "' alt='' >"
				}else{
					html = "<img class='pasteImg' style='width:20px;height:20px' src='" + emojiUrl+ emojiMap[item] + "' alt='' >"
				}
				let sel = window.getSelection()
				let range = this.inputRange
				let el = document.createElement("div")
				let frag = document.createDocumentFragment(),
					node, lastNode

				if(!inputNode) {
					return
				}

				if(!range) {
					inputNode.focus()
					range = window.getSelection().getRangeAt(0)
				}

				range.deleteContents()
				el.innerHTML = html

				while((node = el.firstChild)) {
					lastNode = frag.appendChild(node)
				}
				range.insertNode(frag)

				if(lastNode) {
					range = range.cloneRange()
					range.setStartAfter(lastNode)
					range.collapse(true)
					sel.removeAllRanges()
					sel.addRange(range)
				}
			},
			/**
			 *张俊娜：2019/12/4
			 *描述：复制粘贴图片
			 *版本：1.0
			 */
			copyPaste(e) {
				let sUsrAg = navigator.userAgent;
				let that = this;

				if(e.clipboardData || e.originalEvent) {
					//某些chrome版本使用的是event.originalEvent
					var clipboardData = (e.clipboardData || e.originalEvent.clipboardData);
					if(clipboardData.items) {
						// 是图片
						if(clipboardData.items[0].type.match(/image/)){
							e.preventDefault()
							var blob = clipboardData.items[0].getAsFile();
							var file = new FileReader();
							file.addEventListener('loadend', function(e){
								that.$confirm('是否发送图片?', '提示', {
									confirmButtonText: '确定',
									cancelButtonText: '取消',
									type: 'warning'
								}).then(() => {
									let msg = "<img src='"+e.target.result+"'>"
									that.session.messages.push({
										type:that.$topic.$MESSAGETYPE.ChatImage,
										text: msg,
										date: new Date(),
										self: true,
										imgurl: e.target.result,
										alreadyread:0
									});
									// 上传图片
									that.uploadPasteImg(that.getImgSrc(msg)).then((element) => {
										element.forEach(data => {
											msg = msg.replace(data.base, data.htp)
										})
										that.getImgSrc(msg).forEach(val => {
											that.chatMsg(val,that.$topic.$MESSAGETYPE.ChatImage)
										})
									})	
								}).catch(() => {
									         
								});
							});
							file.readAsDataURL(blob);
							// for chrome
							/*var items = clipboardData.items,
								len = items.length,
								blob = null;
							for(var i = 0; i < len; i++) {
								if(items[i].type.indexOf("image") !== -1) {
									blob = items[i].getAsFile();
								}
							}
							if(blob !== null) {
								var reader = new FileReader();
								reader.readAsDataURL(blob);   
								reader.onload = function() {
									// that.sendEmojiIcon(reader.result)
									if(sUsrAg.indexOf("Firefox") > -1) {
										that.$refs.text.removeChild(document.getElementsByClassName('photo')[0])
									} 
									  
								}
							}*/
						}
					}
				}
			},
			/**
			 *张俊娜：2019/12/9
			 *描述：上传文件
			 *版本：1.0
			 */
			beforeAvatarUpload(file) {
				let _then = this;
        let fd = new FormData();
        fd.append("file",file.file);
        fd.append("type",this.fileType);
        axios({
          hostUrl:this.zuul,
          url:"/xyj-admin/w/FileUploadController/uploadFileType",
          method:"post",
          data:fd
        }).then(res =>{
					// 上传文件
					if(_then.filetype == 2){
						_then.$confirm('是否发送文件?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							_then.file = file.file;
							_then.downloadUrl = res;
							_then.chatMsg(
								JSON.stringify(
									{
										msg:{name:_then.file.name,size:(_then.file.size/1024).toFixed(1)},
										fileurl:_then.downloadUrl
									}
								),
								_then.$topic.$MESSAGETYPE.ChatFile
							)
							_then.session.messages.push({
								type:_then.$topic.$MESSAGETYPE.ChatFile,
								text: {name:_then.file.name,size:(_then.file.size/1024).toFixed(1)},
								fileUrl:_then.downloadUrl,
								date: new Date(),
								self: true,
								alreadyread:0
							}); 
							_then.file = {}
							/*_then.$nextTick(() => {
								// _then.$refs.uploadFile.$el.firstChild
								html2canvas(document.getElementsByClassName('uploadBorder')[0]).then(canvas => {
								// 	// 转成图片，生成图片地址
									let imgUrl = canvas.toDataURL("image/png");
									_then.sendEmojiIcon(imgUrl, 2)
								})
							})*/
						}).catch(() => {});
					}else if(_then.filetype == 1){
						// 上传图片
						//_then.sendEmojiIcon(res,1)
						_then.$confirm('是否发送图片?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							let msg = "<img src='"+res+"'>"
							_then.session.messages.push({
								type:_then.$topic.$MESSAGETYPE.ChatImage,
								text: msg,
								date: new Date(),
								self: true,
								imgurl: msg.match(_then.srcReg)[1],
								alreadyread:0
							});
							_then.chatMsg(msg,_then.$topic.$MESSAGETYPE.ChatImage)
						}).catch(() => {});
					}
        }).catch(err =>{
          _then.$message.error(err.message)
        })
			},
			// 上传文件之前
			beforeAvatarUploadPdf (file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension = testmsg === 'jpg'
        const extension2 = testmsg === 'png'
        const extension4 = testmsg === 'jpeg'
        const extension6 = testmsg === 'gif'
        if (!extension && !extension2 && !extension4 && !extension6) {
          this.filetype = 2
        }else{
					this.filetype = 1
				}
      },
			/**
			 *张俊娜：2019/12/9
			 *描述：历史记录
			 *版本：1.0
			 */
			openHistory(){
				this.$refs.History.open()
			}
		},
		created() {
			/**
			 *宋建国：2019/11/28 17:28
			 *描述：订阅推送页面消息
			 *版本：1.0
			 */
			if(sessionStorage.getItem("chat_funciton") == 1){
				setTimeout(()=>{
					this.$mqtt.ImSubscribe(this.$topic.$IMNEWS, {
						messageArrived: this.imMessageArrived,
						messageDelivered: this.imMessageDelivered
					});
					/**
					 *宋建国：2019/11/28 17:28
					*描述：系统广播页面消息
					*版本：1.0
					*/
					this.$mqtt.ImSubscribe(this.$topic.$IMBROADCAST, {
						messageArrived: this.broadcastArrived,
						messageDelivered: this.broadcastDelivered
					});
				},2000);
			}
		},
	};
</script>

<style lang="scss" scoped>
	.m-text {
  height: 156px;
  border-top: solid 1px #ddd;
  bottom: 2px;
  box-sizing: border-box;
  padding: 10px 15px;
  background: #fff;
  #charInput {
    padding: 10px;
    height: 54%;
    width: 100%;
    border: none;
    outline: none;
    font-family: "Micrsofot Yahei";
    resize: none;
    box-sizing: border-box;
    overflow-y: auto;
		word-break: break-word;
    /deep/ {
      .pasteImg {
        width: 20px;
        height: 20px;
        vertical-align: sub;
      }
    }
		/deep/ img{
			max-height: 200px;
    	max-width: 300px;
		}
  }
  .sendBtn {
    position: absolute;
    bottom: 10px;
    right: 15px;
    // outline: none;
    // width: 60px;
    // height: 30px;
    // color: #666;
    // border-color: #ddd;
    // cursor: pointer;
  }
}
.emoji_tabs_box {
  /deep/ {
    .el-tabs__nav {
      display: flex;
      width: 100%;
    }
    .el-tabs__item {
      flex: 1;
      margin: 0px;
      text-align: center;
      font-weight: 500;
    }
  }
  .emoji_pane_tab {
    font-size: 18px;
  }
  .el-tabs__header {
    margin-bottom: 0;
    padding-top: 5px;
    margin-top: 10px;
    border-top: 1px solid #e6e6e6;
  }
  .el-tabs__active-bar {
    display: none;
  }
}
.el-popover {
  /deep/ {
    .el-tabs__item {
      height: 25px;
    }
  }
  .el-tabs__active-bar {
    background: #409eff;
  }
  .el-button {
    & + .el-button {
      margin-left: 0;
    }
  }
  .chat_emoji_item {
    width: 25px;
    height: 25px;
    margin: 3px;
    cursor: pointer;
    user-select: none;
  }
  .el-tabs__nav-wrap {
    &::after {
      background-color: #fff;
    }
  }
}
.chat_page_con {
  padding: 20px 50px;
  box-sizing: border-box;
  width: 100wv;
  height: 100vh;
  overflow: hidden;
}
@font-face {
  font-family: 'iconfont';
  src: url('//at.alicdn.com/t/font_1098946_1k69hkxpndp.eot');
  src: url('//at.alicdn.com/t/font_1098946_1k69hkxpndp.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_1098946_1k69hkxpndp.woff2') format('woff2'), url('//at.alicdn.com/t/font_1098946_1k69hkxpndp.woff') format('woff'), url('//at.alicdn.com/t/font_1098946_1k69hkxpndp.ttf') format('truetype'), url('//at.alicdn.com/t/font_1098946_1k69hkxpndp.svg#iconfont') format('svg');
}
.chatframe-icon {
  display: inline-block;
  height: 40px;
  border-bottom: 1px solid #e8e8e8;
  vertical-align: top;
  margin-left: 10px;
  .iconfont {
    display: inline-block;
    font-size: 20px;
    cursor: pointer;
  }
  .open_emoji_icon {
    color: #ffbf1f;
  }
}
/deep/ {
  .el-tabs__content {
    height: 330px;
  }
  .el-button {
    margin: 0;
  }
  .photo {
    max-height: 200px;
    max-width: 300px;
  }
}
.upload-demo {
  display: inline-block;
}

  .emojis {
    /*padding: 17px;*/
    height: 300px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    overflow-y: scroll;
    background-color: #fff;
  }

  .emoji {
    height: 25px;
    width: 25px;
    box-sizing: border-box;
  }
  .emoji:hover{
    cursor: pointer;
  }
  .emojiImg {
    width: 25px;
    height: 25px;
  }

</style>



// WEBPACK FOOTER //
// src/components/vueChart/texts.vue